export default function ClipIcon({ className = '' }) {
  return (
    <svg
      className={className}
      width='24'
      height='25'
      viewBox='0 0 24 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_4358_1555)'>
        <path
          d='M21.875 12.548L13.075 21.348C10.575 23.848 6.375 23.848 3.875 21.348C1.375 18.848 1.375 14.648 3.875 12.148L11.675 4.34805C13.475 2.54805 16.275 2.54805 18.075 4.34805C19.875 6.14805 19.875 8.94805 18.075 10.748L10.875 17.848C9.875 18.848 8.275 18.848 7.375 17.848C6.375 16.848 6.375 15.248 7.375 14.348L13.375 8.34805'
          stroke='#442E83'
          strokeWidth='2'
          strokeMiterlimit='10'
          strokeLinecap='square'
        />
      </g>
      <defs>
        <clipPath id='clip0_4358_1555'>
          <rect
            width='24'
            height='24'
            fill='white'
            transform='translate(0 0.998047)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}
